import { Modal, Accordion, Row, Col } from "react-bootstrap"
import { helpModalLabels } from "@revbox/localization";
import { useCookiesContext } from "../../../../contexts/CookiesContext";


const HelpModal = ({ setShowHelp }) => {
  const { getLanguageAbbr } = useCookiesContext();
  const languageAbbr = getLanguageAbbr();
  const translates = helpModalLabels[languageAbbr];
  const { title, hierarchyBiddingRule, bidInheritanceRule, symbols, termsAndConditions, clusterAuctions } = translates;
  return (
        <Modal 
          show={true} 
          onHide={() => setShowHelp(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title><i className="ri-question-line"></i> {title}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="py-3">
            <Row>
              <Col md={6}>
                <h5 className="section-title mb-3">{hierarchyBiddingRule.title}</h5>
                <Accordion defaultActiveKey="" className="accordion-faq">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header><i class="ri-list-ordered me-2"></i>{clusterAuctions.title}</Accordion.Header>
                    <Accordion.Body dangerouslySetInnerHTML={{ __html: clusterAuctions.description }} />
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header><i class="ri-text-wrap me-2"></i>{hierarchyBiddingRule.title}</Accordion.Header>
                    <Accordion.Body dangerouslySetInnerHTML={{ __html: hierarchyBiddingRule.description }} />
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header><i class="ri-sort-desc me-2"></i>{bidInheritanceRule.title}</Accordion.Header>
                    <Accordion.Body dangerouslySetInnerHTML={{ __html: bidInheritanceRule.description }} />
                  </Accordion.Item>
                </Accordion>
              </Col>
              <Col md={1} className="d-flex justify-content-center">
                <div className="divider divider-vertical"></div>
              </Col>
              <Col md={5} className="legend">
                <div className="d-md-none">
                  <div className="divider"></div>
                </div>
                <h5 className="section-title mb-3">{symbols.title}</h5>
                <div className="d-flex">
                  <small className="cluster-level-indicator dc me-3">DC</small>
                  <div>
                    <h6 className="fw-semibold text-dark mb-1">{symbols.dc.title}</h6>
                    <p className="fs-sm text-secondary mb-0">{symbols.dc.description}</p>
                  </div>
                </div>
                <div className="d-flex mt-3">
                  <small className="cluster-level-indicator c1 me-3">C1</small>
                  <div>
                      <h6 className="fw-semibold text-dark mb-1">{symbols.c1.title}</h6>
                    <p className="fs-sm text-secondary mb-0">{symbols.c1.description}</p>
                  </div>
                </div>
                <div className="d-flex mt-3">
                  <small className="cluster-level-indicator c2 me-3">C2</small>
                  <div>
                    <h6 className="fw-semibold text-dark mb-1">{symbols.c2.title}</h6>
                    <p className="fs-sm text-secondary mb-0">{symbols.c2.description}</p>
                  </div>
                </div>
                <div className="d-flex mt-3">
                  <i className="directory-symbol-legend me-3">D</i>
                  <div>
                    <h6 className="fw-semibold text-dark mb-1">{symbols.d.title}</h6>
                    <p className="fs-sm text-secondary mb-0">{symbols.d.description}</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <small className="text-center w-100" dangerouslySetInnerHTML={{ __html: termsAndConditions.description }} />
          </Modal.Footer>
        </Modal>

  )
}

export default HelpModal